import * as React from 'react';

import * as styles from './AuthenticationModal.css';

export const AuthenticationModal: React.FC = ({ children }) => {
  return (
    <div className={styles['container']} data-mark="Authentication">
      {children}
    </div>
  );
};
